import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
/**
 * Created by commyfeng on 2017/3/21.
 */
export default function () {
  var retryTimes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var retryHost = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(next) {
      var _retryTimes, _retryHost;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _retryTimes = retryTimes;
              _retryHost = retryHost || this.request.hostname;
            case 2:
              if (!(_retryTimes >= 0)) {
                _context.next = 19;
                break;
              }
              _retryTimes--;
              _context.prev = 4;
              _context.next = 7;
              return next();
            case 7:
              return _context.abrupt("return");
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](4);
              console.error("\u7B2C ".concat(retryTimes - _retryTimes, "\u6B21\u8BF7\u6C42 ").concat(this.request.url, " \u5931\u8D25"));
              console.error(_context.t0);
              if (!(_retryTimes < 0)) {
                _context.next = 16;
                break;
              }
              throw _context.t0;
            case 16:
              this.request.hostname = _retryHost;
              _context.next = 2;
              break;
            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[4, 10]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}